import { createContext, useState, useEffect } from "react";
import { redirectTologin, getAuthenticatedUser, refreshToken } from "../api/backendApi";
export const AuthContext = createContext();

const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchUser = async () => {
        try {
            const response = await getAuthenticatedUser();
            if (response.status === 200) {
                const userData = await response.json();

                // For testing
                // userData.subscription = {
                //     is_demo_mode: false,
                //     plan_name: "Expert yearly",
                //     price_id: "price_1RVUUVKrjx03t3ccll7GEUh4",
                //     remaining_analyses: 1794
                // }

                setUser(userData);
                console.log('User:', userData);
                if (userData.subscription === null) {
                    const settingsString = localStorage.getItem('virtualAssistantSettings');
                    if (settingsString) {
                        try {
                            const settings = JSON.parse(settingsString);
                            const updatedSettings = {
                                ...settings,
                                on: false,
                                ema: false,
                                channel: false,
                                channelBackground: false,
                            };
                            localStorage.setItem('virtualAssistantSettings', JSON.stringify(updatedSettings));
                        } catch (parseError) {
                            console.warn('Could not parse virtualAssistantSettings:', parseError);
                        }
                    }
                }
            } else if (response.status === 401) {
                await handleRefreshToken();
            }
        } catch (error) {
            console.error('Error fetching user:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleRefreshToken = async () => {
        try {
            const response = await refreshToken();
            if (response.status === 200) {
                const data = await response.json();
                await fetchUser(); 
            } else{
                setUser(null);
                redirectTologin();
            } 
        } catch (error) {
            console.error('Error refreshing token:', error);
            setUser(null);
            redirectTologin();
        }
    };

    useEffect(() => {
        fetchUser();
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            {loading ? <div>Loading...</div> : children} { /* Change to a loader */}
        </AuthContext.Provider>
    );
};

export default AuthProvider;
